// extracted by mini-css-extract-plugin
export var boldText = "_42-4";
export var checkboxContainer = "_42-6";
export var closeIcon = "_42-i";
export var container = "_42-0";
export var drawer = "_42-8";
export var drawerContent = "_42-9";
export var extraSmallText = "_42-5";
export var fulfillmentGroupTable = "_42-e";
export var largeText = "_42-3";
export var loadingSpinnerContainer = "_42-j";
export var mediumText = "_42-2";
export var narrow = "_42-f";
export var notificationLink = "_42-l";
export var packageCheckIconContainer = "_42-7";
export var slideoutHeaderActions = "_42-g";
export var slideoutHeaderActionsShifted = "_42-h";
export var slideoutHeaderContainer = "_42-a";
export var slideoutModal = "_42-c";
export var stickyHeaderWrapper = "_42-b";
export var table = "_42-k";
export var tableContainer = "_42-d";
export var tertiaryText = "_42-1";